exports.onRouteUpdate = () => {
  if (typeof window !== `undefined`) {
    window.scrollTo(0, 0);
  }
};

exports.shouldUpdateScroll = (args) => {
  return false;
};

const { wrapRootElement } = require("./gatsby-ssr");
exports.wrapRootElement = wrapRootElement;
